import deepExtend from "deep-extend";

function events(state = {}, action) {
  switch (action.type) {
    case "CLEAR_EVENTS":
      return {};

    case "FETCH_EVENTS":
      let newState = {};
      action.payload.forEach((event) => {
        newState = {
          ...newState,
          [event.uuid]: {
            ...event
          }
        };
      });
      return newState;

    case "ADD_EVENT_DETAILS":
      var newState = Object.assign({}, state);
      var addState = {
        [action.eventId]: {
          ...action.payload
        }
      };
      deepExtend(newState, addState);
      return newState;

    case "GETTING_EVENT_DETAILS":
      var newState = Object.assign({}, state);
      var addState = {
        [action.eventId]: {
          loading_details: true
        }
      };
      deepExtend(newState, addState);
      return newState;

    default:
      return state;
  }
  return state;
}

export default events;



// WEBPACK FOOTER //
// ./reducers/events.js